var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMagnumagentie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112,
    height: 56,
    viewBox: "0 0 112 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54778",
    "data-name": "Path 54778",
    d: "M0,13.522q0,.167,0,.334H0C0,24.4,11.853,34.662,12.356,35.094a2.053,2.053,0,0,0,2.669,0c.5-.433,12.353-10.692,12.353-21.237A13.689,13.689,0,0,0,13.857,0h-.17A13.689,13.689,0,0,0,0,13.522",
    transform: "translate(0 0)",
    fill: "#12121b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54768",
    "data-name": "Path 54768",
    d: "M288.219,295.215q0,.162,0,.323h0c0,10.209,11.469,20.137,11.956,20.554a1.987,1.987,0,0,0,2.583,0c.487-.419,11.956-10.348,11.956-20.554a13.249,13.249,0,0,0-13.087-13.41h-.165a13.249,13.249,0,0,0-13.245,13.087",
    transform: "translate(-288.218 -282.127)",
    fill: "#bfbfbf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Magnum.agentie",
    transform: "translate(-277 -735)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5220",
    "data-name": "Rectangle 5220",
    width: 112,
    height: 56,
    transform: "translate(277 735)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24757",
    "data-name": "Group 24757",
    transform: "translate(296.413 735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24739",
    "data-name": "Group 24739",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54810",
    "data-name": "Path 54810",
    d: "M0,0H62.073V31.522H0Z",
    transform: "translate(3.139 19.622)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24758",
    "data-name": "Group 24758",
    transform: "translate(0 7.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54757",
    "data-name": "Path 54757",
    d: "M0,188.537v3.987a6.748,6.748,0,0,0,6.835,6.835,6.748,6.748,0,0,0,6.835-6.835v-3.987Z",
    transform: "translate(0 -178.854)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54758",
    "data-name": "Path 54758",
    d: "M102.4,188.537v3.987a6.835,6.835,0,0,0,13.67,0v-3.987Z",
    transform: "translate(-88.73 -178.854)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54759",
    "data-name": "Path 54759",
    d: "M204.8,188.537v3.987a6.835,6.835,0,0,0,13.67,0v-3.987Z",
    transform: "translate(-177.459 -178.854)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54760",
    "data-name": "Path 54760",
    d: "M307.2,188.537v3.987a6.835,6.835,0,0,0,13.67,0v-3.987Z",
    transform: "translate(-266.193 -178.854)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54761",
    "data-name": "Path 54761",
    d: "M409.6,188.537v3.987a6.835,6.835,0,0,0,13.67,0v-3.987Z",
    transform: "translate(-354.919 -178.854)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54762",
    "data-name": "Path 54762",
    d: "M13.67,125.686,18.8,116H8.686L0,125.686Z",
    transform: "translate(0 -116.003)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54763",
    "data-name": "Path 54763",
    d: "M116.07,125.686,117.779,116H107.526l-5.126,9.683Z",
    transform: "translate(-88.73 -116.003)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54764",
    "data-name": "Path 54764",
    d: "M218.47,125.686,216.761,116H206.509l-1.709,9.683Z",
    transform: "translate(-177.459 -116.003)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54765",
    "data-name": "Path 54765",
    d: "M309.779,125.686,304.652,116H294.4l1.709,9.683Z",
    transform: "translate(-255.099 -116.003)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54766",
    "data-name": "Path 54766",
    d: "M390,125.686,381.31,116H371.2l5.126,9.683Z",
    transform: "translate(-321.646 -116.003)",
    fill: "#3e3e3e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5210",
    "data-name": "Rectangle 5210",
    d: "M1,0H46.838a1,1,0,0,1,1,1V12.086a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1A1,1,0,0,1,1,0Z",
    transform: "translate(10.171 0)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54767",
    "data-name": "Path 54767",
    d: "M86.187,323.453H98.934c1.65,0,2.987,1.009,2.987,2.253v18.322H83.2V325.706c0-1.245,1.337-2.253,2.987-2.253",
    transform: "translate(-73.03 -292.884)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24733",
    "data-name": "Group 24733",
    transform: "translate(35.684 16.32) rotate(8)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5213",
    "data-name": "Rectangle 5213",
    width: 27.377,
    height: 35.59,
    transform: "translate(0.003 -0.005)",
    fill: "#12121b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24731",
    "data-name": "Group 24731",
    transform: "translate(30.732 18.625)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54782",
    "data-name": "Path 54782",
    d: "M0,0H26.5V34.445H0Z",
    transform: "translate(0.003 -0.005)",
    fill: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24735",
    "data-name": "Group 24735",
    transform: "translate(43.68 27.352)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54769",
    "data-name": "Path 54769",
    d: "M357.371,352.071a5.788,5.788,0,0,1-1.5-.2,5.046,5.046,0,0,1-4.108-4.128,1.215,1.215,0,1,1,2.395-.406,2.618,2.618,0,0,0,2.169,2.148,1.223,1.223,0,0,1,.136.03,3.273,3.273,0,0,0,3.852-1.734,2.226,2.226,0,0,0,.053-.288,2.317,2.317,0,0,0-2.116-2.5h-.258c-2.9,0-4.285-.588-5.475-2.331a4.592,4.592,0,0,1-.413-.766l-.076-.2a4.492,4.492,0,0,1,2.671-5.71,6.32,6.32,0,0,1,6.06.491,1.215,1.215,0,0,1-1.344,2.022,3.873,3.873,0,0,0-3.746-.288c-.034.015-.068.029-.1.042a2.061,2.061,0,0,0-1.249,2.63,2.208,2.208,0,0,0,.216.422c.609.883,1.1,1.26,3.462,1.26h.353a4.67,4.67,0,0,1,4.264,5.981,1.211,1.211,0,0,1-.058.157,5.686,5.686,0,0,1-5.182,3.372",
    transform: "translate(-351.745 -333.596)",
    fill: "#fffe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54770",
    "data-name": "Path 54770",
    d: "M392.4,322.571a1.214,1.214,0,0,1-1.215-1.212v-1.443a1.215,1.215,0,0,1,2.43,0v1.438a1.214,1.214,0,0,1-1.21,1.217H392.4",
    transform: "translate(-386.852 -318.705)",
    fill: "#fffe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54771",
    "data-name": "Path 54771",
    d: "M386,473.257a1.213,1.213,0,0,1-1.215-1.212V470.6a1.215,1.215,0,0,1,2.43,0v1.438a1.214,1.214,0,0,1-1.21,1.217H386",
    transform: "translate(-380.253 -452.864)",
    fill: "#fffe00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_54809",
    "data-name": "Path 54809",
    d: "M0,12.235V9.826H.825V3.046H.184V.726H4.219s2.7,4.209,2.935,4.639h.092C7.5,4.935,10.272.726,10.272.726h4.035v2.32h-.642v6.78h.825v2.409H9.263V9.826h.825V5.454H10L8.071,8.666H6.329L4.494,5.454H4.4V9.826h.825v2.409Z",
    transform: "translate(37.542 28.131)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "magnum_logo",
    transform: "translate(12.961 2.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52365",
    "data-name": "Path 52365",
    d: "M128.754.726V6.75h-2.016l-1.585-2.615c-.1-.163-.382-.7-.382-.7h-.048V5.489h.432V6.75h-2.736V5.489h.432V1.94h-.336V.726h2.3L126.46,3.3a7.772,7.772,0,0,1,.374.744h.048V1.94H126.5V.726Z",
    transform: "translate(-101.489 -0.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52366",
    "data-name": "Path 52366",
    d: "M51.789,2.127h.048l.528,2.054h-1.1Zm-2.16-1.4V1.94h.384L49.005,5.489h-.432V6.75h2.16l.336-1.261h1.488l.336,1.261h2.16L53.374.726Z",
    transform: "translate(-40.269 -0.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52367",
    "data-name": "Path 52367",
    d: "M90.438,6.269c-1.506,0-2.836-.47-2.836-2.876v-.56C87.6.306,89.089,0,90.487,0a11.688,11.688,0,0,1,2.347.264V1.9h-1.2v-.42c-.207-.008-.536-.047-.768-.047-.927,0-1.392.105-1.392,1.4v.56c0,1.167.3,1.494,1.008,1.494h.576V3.813h-.432v-.98h2.208V6.054a13.944,13.944,0,0,1-2.4.215",
    transform: "translate(-72.625 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52368",
    "data-name": "Path 52368",
    d: "M169.5.726l0,1.26V4.328c0,1.722-1,2.543-2.732,2.543s-2.732-.821-2.732-2.543l0-2.388h-.336V.726H165.9l0,1.26V4.3c0,.9.182,1.215.869,1.215s.869-.322.869-1.215l-.005-2.364h-.336V.726Z",
    transform: "translate(-135.706 -0.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52369",
    "data-name": "Path 52369",
    d: "M0,6.75V5.489H.432V1.94H.1V.726H2.208s1.412,2.2,1.536,2.428h.048C3.925,2.929,5.376.726,5.376.726H7.488V1.94H7.152V5.489h.432V6.75H4.848V5.489H5.28V3.2H5.232L4.224,4.882H3.312L2.352,3.2H2.3V5.489h.432V6.75Z",
    transform: "translate(0 -0.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52370",
    "data-name": "Path 52370",
    d: "M201.878,6.75V5.489h.432V1.94h-.336V.726h2.112s1.412,2.2,1.536,2.428h.048c.132-.225,1.584-2.428,1.584-2.428h2.112V1.94h-.336V5.489h.432V6.75h-2.736V5.489h.432V3.2h-.048L206.1,4.882h-.912L204.23,3.2h-.048V5.489h.432V6.75Z",
    transform: "translate(-167.364 -0.602)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMagnumagentie);
export default __webpack_public_path__ + "static/media/Logo_Magnum.agentie.011302d1e749bf1e6d8913de94096467.svg";
export { ForwardRef as ReactComponent };